import type { RendererProps } from "../core/element-registry"
import { useRenderContext } from "../core/render-context"
import { ElementRenderer } from "./element-renderer"
import { cn } from "../lib/utils"

export function BreadcrumbRenderer({ element }: RendererProps) {
  const { resolveSymbol, dispatchEvent } = useRenderContext()

  const items = element.children ?? []
  const separator = element.variant === "chevron" ? ">" : "/"

  return (
    <nav
      className={cn("flex items-center gap-2 text-sm", element.className)}
      data-testid={`breadcrumb-${element.id}`}
      aria-label="Breadcrumb"
    >
      {items.map((child, i) => {
        const isLast = i === items.length - 1
        const label = child.text ? String(resolveSymbol(child.text) ?? "") : ""

        return (
          <span key={child.id} className="flex items-center gap-2">
            {i > 0 && (
              <span className="text-muted-foreground" aria-hidden="true">
                {separator}
              </span>
            )}
            {child.type === "button" ? (
              <button
                type="button"
                className="text-sm font-medium text-muted-foreground transition-colors hover:text-foreground"
                onClick={() => dispatchEvent(child.id, "tap", { value: label })}
              >
                {label}
              </button>
            ) : (
              <ElementRenderer element={child} />
            )}
          </span>
        )
      })}
    </nav>
  )
}
